import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutHero.css';

export default function AboutHero() {
  const navigate = useNavigate();

  return (
    <section className="ah">
      <div className="ah__inner">

        {/* LEFT: The Narrative */}
        <div className="ah__left">
          <p className="ah__eyebrow">A b o u t &nbsp; U s</p>

          <h1 className="ah__title">
            <span>OUR</span>
            <span className="ah__title-red">STORY</span>
          </h1>

          <div className="ah__manifesto">
            <p className="ah__body">
              SA Dropped wasn't born in a boardroom. It started in Durban
              with a bedroom full of sneakers, a passion that couldn't be
              contained, and a community that believed in the culture before
              anyone else did. We don't just sell shoes — we archive the
              heat that defines South African street culture.
            </p>
          </div>

          <div className="ah__timeline">
            <div className="ah__time-node">
              <span className="ah__node-year">2019</span>
              <p className="ah__node-text">The Bedroom Hustle</p>
            </div>
            <div className="ah__time-connector" />
            <div className="ah__time-node">
              <span className="ah__node-year">2025</span>
              <p className="ah__node-text">The Cultural Hub</p>
            </div>
          </div>

          <button className="ah__cta-unified" onClick={() => navigate('/products')}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 2 3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 01-8 0"/>
            </svg>
            SHOP THE STORY
          </button>
        </div>

        {/* CENTRE: The Visual Anchor */}
        <div className="ah__centre">
          <div className="ah__image-composition">
            <div className="ah__main-frame">
              <img
                src="https://images.unsplash.com/photo-1552346154-21d32810aba3?w=800&q=90"
                alt="Sneaker culture"
                className="ah__img-main"
              />
              <div className="ah__img-overlay-text">FOUNDED IN DURBAN</div>
            </div>
            <div className="ah__sub-frame">
              <img
                src="https://images.unsplash.com/photo-1603787081151-cbebeef20092?w=400&q=80"
                alt="Durban roots"
                className="ah__img-sub"
              />
            </div>
          </div>
        </div>

        {/* RIGHT: The Pillars */}
        <div className="ah__right">
          <div className="ah__pillar-block">
            <span className="ah__pillar-num">01</span>
            <h4 className="ah__pillar-hd">CRAFT</h4>
            <p className="ah__pillar-desc">Beyond the hype, it's about the construction and the heritage.</p>
          </div>
          <div className="ah__pillar-block">
            <span className="ah__pillar-num">02</span>
            <h4 className="ah__pillar-hd">COMMUNITY</h4>
            <p className="ah__pillar-desc">Built for the culture, by the culture.</p>
          </div>
          <div className="ah__pillar-block">
            <span className="ah__pillar-num">03</span>
            <h4 className="ah__pillar-hd">LEGACY</h4>
            <p className="ah__pillar-desc">Preserving the story of every drop.</p>
          </div>
        </div>

      </div>
    </section>
  );
}